(() => {
  const desktopMediaQuery = window.matchMedia('(min-width: 1024px)');
  const reducedMotionMediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

  const getCarouselStep = (rail) => {
    const card = rail.querySelector('.fnav-item');
    if (!card) return rail.clientWidth;

    const gap = Number.parseFloat(window.getComputedStyle(rail).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  };

  const initializeCarousel = (section) => {
    const rail = section.querySelector('[data-fnav-carousel]');
    const controls = section.querySelector('[data-fnav-carousel-controls]');
    const previousButton = section.querySelector('[data-fnav-carousel-prev]');
    const nextButton = section.querySelector('[data-fnav-carousel-next]');

    if (!rail || !controls || !previousButton || !nextButton || section.dataset.fnavCarouselInitialized === 'true') {
      return;
    }

    section.dataset.fnavCarouselInitialized = 'true';

    const updateControls = () => {
      const maxScrollLeft = Math.max(0, rail.scrollWidth - rail.clientWidth);
      const carouselIsAvailable = desktopMediaQuery.matches && maxScrollLeft > 1;

      controls.hidden = !carouselIsAvailable;
      previousButton.disabled = !carouselIsAvailable || rail.scrollLeft <= 1;
      nextButton.disabled = !carouselIsAvailable || rail.scrollLeft >= maxScrollLeft - 1;
    };

    const scrollRail = (direction) => {
      rail.scrollBy({
        left: direction * getCarouselStep(rail),
        behavior: reducedMotionMediaQuery.matches ? 'auto' : 'smooth',
      });
    };

    previousButton.addEventListener('click', () => scrollRail(-1));
    nextButton.addEventListener('click', () => scrollRail(1));
    rail.addEventListener('scroll', updateControls, { passive: true });
    desktopMediaQuery.addEventListener('change', updateControls);

    if ('ResizeObserver' in window) {
      new ResizeObserver(updateControls).observe(rail);
    }

    window.requestAnimationFrame(updateControls);
  };

  const initialize = (scope = document) => {
    const sections = [];

    if (scope.matches?.('[data-wetheme-section-type="section-visual-navigation-banner"]')) {
      sections.push(scope);
    }

    sections.push(...scope.querySelectorAll?.('[data-wetheme-section-type="section-visual-navigation-banner"]') || []);
    sections.forEach(initializeCarousel);
  };

  if (window.FootwearNavigationCards) {
    window.FootwearNavigationCards.initialize(document);
    return;
  }

  window.FootwearNavigationCards = { initialize };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
